<template>
    <div class="about">
        <div class="header">
            <img src="../assets/icons/about-header-bg.svg" class="header__bg" alt="background" />
            <h1>Kontakt / info</h1>
        </div>

        <ContentBox>
            <b>Urząd Miasta Jastrzębie-Zdrój</b><br />
            al. Józefa Piłsudskiego 60,<br />
            44-335 Jastrzębie-Zdrój
            <p>
                <a href="tel:324785100"> tel. 32 47 85 100 </a><br />
                <a href="mailto:miasto@um.jastrzebie.pl"> miasto@um.jastrzebie.pl </a><br />
                <a href="https://www.jastrzebie.pl/" target="_blank" rel="noopener noreferrer">
                    www.jastrzebie.pl
                </a>
            </p>
            <p>
                <a href="https://www.facebook.com/MiastoJastrzebieZdroj/" target="_blank" class="social-link">
                    <img src="../assets/icons/icon_social-media_facebook.svg" alt="facebook logo" />
                </a>
                <a href="https://www.instagram.com/mojejastrzebie/" target="_blank" class="social-link">
                    <img
                        src="../assets/icons/icon_social-media_instagram.svg"
                        alt="facebook logo"
                    />
                </a>
            </p>
        </ContentBox>

        <ContentBox>
            <h3>Jastrzębski Eko-poradnik, czyli co?</h3>
            <p>
                Jastrzębski Miejski Eko-poradnik to zbiór porad dotyczących zrównoważonego stylu
                życia, a także codziennego funkcjonowania w zgodzie z zasadami energooszczędności i
                ekologii. Dzięki poradnikowi przekonasz się, że życie w zgodzie ze środowiskiem
                wcale nie musi być trudne!
            </p>
        </ContentBox>
        <ContentBox>
            <h3>Czym jest zrównoważony rozwój?</h3>
            <p>
                Chodzi o takie życie i gospodarowanie zasobami, abyśmy nie tylko zaspokajali nasze
                potrzeby, ale też dbali o to, aby przyszłe pokolenia mogły funkcjonować w
                przyjaznym, zdrowym środowisku naturalnym. W poradniku zebraliśmy wskazówki, które
                pozwolą nam zatroszczyć się o powietrze, wodę, energię i klimat, a także ograniczyć
                ilość wytwarzanych odpadów. Okazuje się, że niewielkie zmiany w naszym codziennym
                zachowaniu to szansa na czyste i przyjazne środowisko oraz niemałe oszczędności
                finansowe. Pobierz i korzystaj z Eko-poradnika w każdej chwili!
            </p>
        </ContentBox>
    </div>
</template>

<script>
    import ContentBox from '@/components/ContentBox.vue';

    export default {
        name: 'About',
        components: {
            ContentBox,
        },
    };
</script>

<style lang="scss" scoped>
    .about {
        background-color: $light-green;
        padding-bottom: 200px;
        z-index: 100;

        a {
            text-decoration: none;
            color: $dark-green;
        }

        .header {
            position: relative;
            margin-bottom: $margin;
            background-color: $light-green;

            &__bg {
                width: 100%;
                max-width: 375px;
            }

            h1 {
                position: absolute;
                left: 0;
                top: 20px;
                width: 100%;
                font-size: $big-text;
                line-height: 37px;
                color: $green;
                text-align: center;
                margin: 0;
            }
        }

        .social-link {
            margin-right: 10px;

            &:hover {
                text-decoration: none;
            }

            img {
                width: 30px;
            }
        }
    }
</style>
